import {useQuery} from '@tanstack/react-query'
import builderConfig from 'hec/builder/model-map'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {fetchOneEntry} from '@builder.io/sdk-react'

const useFetchModule = (moduleContentID) => {
    const apiKey = getConfig().app.builder.api

    return useQuery({
        queryKey: ['Fetch-Learning-Center-Module', moduleContentID],
        queryFn: async () => {
            const response = await fetchOneEntry({
                apiKey: apiKey,
                model: builderConfig.learningCenterModule,
                query: {
                    id: moduleContentID
                },
                fields: 'id,data'
            })

            await Promise.all(
                response.data.lessons.map(async (builderLesson) => {
                    const lessonContent = builderLesson.lesson.value.data.content
                    const contentRes = await fetchOneEntry({
                        apiKey: apiKey,
                        model: builderConfig.learningCenterLessonContent,
                        query: {
                            id: lessonContent.id
                        },
                        fields: 'data'
                    })

                    builderLesson.lesson.value.data.content = contentRes
                })
            )

            return response
        },
        enabled: !!moduleContentID
    })
}

export default useFetchModule
